import { createFileRoute } from "@tanstack/react-router";
import WhyUs from "@/pages/WhyUs";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/warum-wir/")({
  head: () => routeHead("/de/warum-wir/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <WhyUs />
  );
}
